import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/en/services/pharmacovigilance/pharmacovigilance-certified-blended-training")({
  head: () => buildRouteHead("/en/services/pharmacovigilance/pharmacovigilance-certified-blended-training"),
  component: PVOffering,
});

